import ENDPOINTS from 'api/endpoints';
import { doDelete, doGet, doPost } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';
import type {
  CreateWebRTCConnectionRequest,
  GetWebRTCConnectionResponse,
  KbTopicsPreviewResponse,
  WebRTCConnectionResponse,
} from './types';

export const createWebRTCConnection = (body: CreateWebRTCConnectionRequest) =>
  doPost<WebRTCConnectionResponse>(
    ENDPOINTS.WEBRTC_CONNECTIONS,
    LOGGER_TYPE.AGENT_STREAM,
    body,
    { prefix: 'sourcerer' },
  );

export const getWebRTCConnection = (connectionId: string) =>
  doGet<GetWebRTCConnectionResponse>(
    generateNextPath(ENDPOINTS.WEBRTC_CONNECTION, { connectionId }),
    LOGGER_TYPE.AGENT_STREAM,
    { prefix: 'sourcerer', noAuth: true },
  );

export const getKbTopicsPreview = (agentId: string) =>
  doGet<KbTopicsPreviewResponse>(
    generateNextPath(ENDPOINTS.PUBLIC_KB_TOPICS_PREVIEW, { agentId }),
    LOGGER_TYPE.AGENT_STREAM,
    { prefix: 'sourcerer', noAuth: true },
  );

export const deleteWebRTCConnection = ({
  accountId,
  projectId,
  clientEnv,
}: {
  accountId: string;
  projectId: string;
  clientEnv: string;
}) =>
  doDelete<void>(
    generateNextPath(ENDPOINTS.DELETE_WEBRTC_CONNECTION, {
      accountId,
      projectId,
      clientEnv,
    }),
    LOGGER_TYPE.AGENT_STREAM,
    undefined,
    { prefix: 'sourcerer' },
  );
